export const SUPPORTED_LOCALES = [
    "fr-FR",
    "de-DE",
    "en-GB",
    "es-ES",
    "nl-NL",
    "it-IT",
    "fr-BE",
    "fr-CH",
] as const;

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

// Map entre codes courts et locales complètes
export const LOCALE_MAP: Record<string, SupportedLocale> = {
    fr: "fr-FR",
    de: "de-DE",
    en: "en-GB",
    es: "es-ES",
    nl: "nl-NL",
    it: "it-IT",
    be: "fr-BE",
    ch: "fr-CH",
};